import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LANGUAGES } from "@/i18n/languages";
import { GB, FR, ES, DE, IT } from "country-flag-icons/react/3x2";

const FLAGS = { GB, FR, ES, DE, IT };

export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const active = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  const current = LANGUAGES.find((l) => l.code === active) || LANGUAGES[0];
  const CurrentFlag = FLAGS[current.country];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={`Language: ${current.label}`}
        className={`inline-flex items-center gap-2 rounded-md px-2 py-1 text-sm text-[#A1A1AA] hover:text-white focus:outline-none ${className}`}
      >
        <CurrentFlag className="h-4 w-6 rounded-sm" title={current.label} />
        <span>{current.label}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        {LANGUAGES.map((lng) => {
          const Flag = FLAGS[lng.country];
          return (
            <DropdownMenuItem
              key={lng.code}
              onSelect={() => i18n.changeLanguage(lng.code)}
              className="flex cursor-pointer items-center gap-2"
            >
              <Flag className="h-4 w-6 rounded-sm" title={lng.label} />
              <span>{lng.label}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
